// extracted by mini-css-extract-plugin
module.exports = {"establishments":"ShoppingWindow_establishments__3x1f5","header":"ShoppingWindow_header__1bQ7s","tableHeader":"ShoppingWindow_tableHeader__32BPX"};